export default `query {
  customAttributeMetadata(attributes: [      
    {
        attribute_code: "mastercolor"
        entity_type: "catalog_product"
    },
    {
        attribute_code: "size"
        entity_type: "catalog_product"
    },
    {
        attribute_code: "labels_sales"
        entity_type: "catalog_product"
    },
    {
        attribute_code: "campaign"
        entity_type: "catalog_product"
    }, 
    {
        attribute_code: "promotion_image_list"
        entity_type: "catalog_product"
    }, 
    {
        attribute_code: "promotion_image_detail"
        entity_type: "catalog_product"
    }]) {
    items {
        attribute_code
        attribute_options {
            is_default
            value
            label
            swatch_link
            swatch {
                option_id
                value
                type
            }
        }
        attribute_type
        entity_type
        input_type
    }
  }
}`;